<template>
    <section>
        <div v-if="has_sort" class="filter-bar">
            <div class="filter-bar__filters">
                <span>Sort By:</span>
                <div class="filter-bar__filters-option" :class="{'filter-bar__filters-option--active': sort === 'relevance' || sort === null}">
                    <a @click="sort = 'relevance'" role="button" href="javascript:void(0)">
                        <span>Relevance</span>
                    </a>
                </div>
                <div class="filter-bar__filters-option" :class="{'filter-bar__filters-option--active': sort === 'date'}">
                    <a @click="sort = 'date'" role="button" href="javascript:void(0)">
                        <span>Date</span>
                    </a>
                </div>
            </div>
        </div>
        <div v-if="has_sort" class="field filter-bar filter-bar--mobile">
            <div class="control">
                <div class="select select--fullwidth">
                    <select name="filter" id="sort" v-model="sort">
                        <option value="relevance">Relevance</option>
                        <option value="date">Date</option>
                    </select>
                </div>
            </div>
        </div>
        <div v-if="has_filter" class="filter-bar">
            <div class="filter-bar__filters">
                <span>Filter By Topic:</span>
                <div v-for="f in filters" class="filter-bar__filters-option" :class="{'filter-bar__filters-option--active': filter === f.value}">
                    <a @click="filter = f.value" role="button" href="javascript:void(0)">
                        <span>{{ f.name }}</span>
                    </a>
                </div>
            </div>
            <a role="button" class="filter-bar__search-option" @click="searching = !searching">
                <i class="icon-search"></i>
            </a>
        </div>
        <div v-if="has_filter" class="field filter-bar filter-bar--mobile">
            <div class="control">
                <div class="select select--fullwidth">
                    <select name="filter" id="filter" v-model="filter">
                        <option v-for="f in filters" :value="f.value">{{ f.name }}</option>
                    </select>
                </div>
            </div>
        </div>
        <posts-search v-if="has_filter" :display="searching" :icon="false" :query="q"></posts-search>
        <div class="post-list" :class="{'post-list--loading': initializing}">
            <article v-for="post in posts" class="post-preview">
                <div class="post-preview__image">
                    <a :href="post.route">
                        <img :src="post.photo_preview_mobile" alt="" class="u-hidden--tablet image--128x128">
                        <img :src="post.photo_preview" alt="" class="u-hidden--mobile">
                    </a>
                </div>
                <div class="post-preview__content">
                    <h4 class="post-preview__title"><a :href="post.route">{{ post.title }}</a></h4>
                    <p class="post-preview__body u-hidden--tablet">{{ post.excerpt_preview_mobile }}</p>
                    <p class="post-preview__body u-hidden--mobile">{{ post.excerpt_preview }}</p>
                    <div class="post-preview__author">
                        <span class="body body--xs">
                            By {{ post.author.full_name }}
                            <span v-if="post.photographer" class="u-hidden--mobile">| Photos by {{ post.photographer.name }}</span>
                            <span v-else-if="post.photo.contributor" class="u-hidden--mobile">| Photo by {{ post.photo.contributor.name }}</span>
                            <span v-if="post.illustrator" class="u-hidden--mobile">| Illustrated by {{ post.illustrator.name }}</span>
                            | {{ post.read_time }} min <span class="u-hidden--mobile">read</span>
                        </span>
                        <span class="u-hidden--mobile">
                        <a :href="post.route" class="post-preview__button">{{ post.read_type }}</a>
                    </span>
                    </div>
                </div>
            </article>
            <h5 v-show="!initializing && posts.length === 0">Uh Oh! No posts found.</h5>
            <div v-show="next_page" class="search-section__results__view-more">
                <button class="button button--arrow button--arrow-down" :class="{'button--arrow-loading': loading}" type="button" @click="next">View More</button>
            </div>
        </div>
    </section>
</template>

<script>
    import {EventBus} from "../event-bus";

    export default {
        props: {
            url: String,
            has_filter: {
                type: Boolean,
                default: true
            },
            filter_title: {
                type: String,
                default: 'Filter:'
            },
            has_sort: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                initializing: true,
                posts: [],
                next_page: null,
                loading: false,
                filter: 'all',
                q: null,
                searching: false,
                sort: 'relevance',
                filters: [
                    {
                        name: 'All',
                        value: 'all'
                    }, {
                        name: 'Travel',
                        value: 'travel',
                    }, {
                        name: 'Food',
                        value: 'food',
                    }, {
                        name: 'History/Culture',
                        value: 'history-culture',
                    }
                ]
            };
        },
        created() {
            let vm = this;

            vm.setRequestParams();
            let requestParams = vm.getRequestParams(false);

            vm.sendRequest(requestParams.url).then(function() {
                vm.initializing = false;
            });

            EventBus.$on('search', (q) => {
                vm.searchRequest(q);
            });
        },
        watch: {
            filter(v) {
                this.next_page = null;
                this.filterRequest(v);
            },
            sort(v) {
                this.sortRequest(v);
            }
        },
        methods: {
            next() {
                let vm = this;
                if (vm.next_page) {
                    vm.loading = true;
                    let requestParams = vm.getRequestParams(false);
                    vm.sendRequest(requestParams.url).then(function() {
                        vm.loading = false;
                    });
                }
            },
            searchRequest(q) {
                let vm = this;
                vm.posts = [];
                vm.initializing = true;
                vm.q = q;

                let requestParams = vm.getRequestParams(true);

                vm.sendRequest(requestParams.url).then(function() {
                    vm.initializing = false;
                });
            },
            filterRequest(filter) {
                let vm = this;
                vm.filter = filter;
                vm.posts = [];
                vm.initializing = true;

                let requestParams = vm.getRequestParams(true);

                vm.sendRequest(requestParams.url).then(function() {
                    vm.initializing = false;
                });
            },
            sortRequest(sort) {
                let vm = this;
                vm.sort = sort;
                vm.posts = [];
                vm.initializing = true;
                let requestParams = vm.getRequestParams(true);
                vm.sendRequest(requestParams.url).then(function() {
                    vm.initializing = false;
                });
            },
            sendRequest(url) {
                let vm = this;

                return this.$http.get(url).then(function(data) {
                    let posts = data.data.data;
                    vm.posts = vm.posts.concat(posts);
                    EventBus.$emit('posts-total', data.data.total);

                    vm.next_page = null;
                    if (data.data.next_page_url && data.data.current_page) {
                        vm.next_page = data.data.current_page + 1;
                    }

                    return true;
                }).catch(function() {
                    return false;
                });
            },
            getRequestParams(updateHistory) {
                let vm = this;
                let searchParams = new URLSearchParams();
                let baseUrl = vm.url.split('?')[0];
                let params = vm.url.match(/(\?.*)/);

                if (params && params[1]) {
                    searchParams = new URLSearchParams(params[1]);
                }

                if (vm.filter !== 'all') {
                    searchParams.set('filter', vm.filter);
                } else {
                    searchParams.delete('filter');
                }

                if (vm.q) {
                    searchParams.set('q', vm.q);
                }

                if (vm.sort) {
                    searchParams.set('sort', vm.sort);
                }

                if (updateHistory) {
                    let historyUrl = baseUrl;

                    if (searchParams.toString() !== '') {
                        historyUrl += `?${searchParams.toString()}`;
                    }

                    history.pushState('', '', historyUrl);
                }

                if (vm.next_page) {
                    searchParams.set('page', vm.next_page);
                }

                searchParams.set('ajax', 'true');

                return {
                    url: `${baseUrl}?${searchParams.toString()}`,
                    baseUrl,
                    searchParams
                };
            },
            setRequestParams() {
                let vm = this;
                let searchParams = new URLSearchParams(window.location.search);

                searchParams.forEach((param, key) => {
                    if (vm.hasOwnProperty(key)) {
                        vm[key] = param;
                    }
                });

                if (vm.q) {
                    vm.searching = true;
                }
            }
        }
    };
</script>

